var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length > 0)?_c('v-treeview',{attrs:{"dense":"","hoverable":true,"items":_vm.items},scopedSlots:_vm._u([{key:"label",fn:function(ref){
var item = ref.item;
return [_c('a',{staticClass:"text-wrap",attrs:{"data-test-toc-entry":""},domProps:{"innerHTML":_vm._s(item.name)},on:{"click":function($event){return _vm.scrollToRequirementKey(item.key)}}})]}}],null,false,2677157118)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }